<template>
  <div class="app-with-loading-container">
    <Preloader v-if="localLoading" />
    <div v-show="!localLoading" class="app-with-loading-slot">
      <slot :loader="withLoading" :localLoading="localLoading" />
    </div>
  </div>
</template>

<script>
import Preloader from '@/components/Preloader';
import useValidation from '@/compositions/useValidation';

export default {
  name: 'AppWithLoading',
  components: { Preloader },
  props: {
    fetch: {
      type: Function,
      default: null,
    },
  },
  setup({ fetch }) {
    const { withLoading, localLoading } = useValidation();

    if (typeof fetch === 'function') {
      withLoading(async () => {
        await fetch();
      });
    }

    return {
      localLoading,
      withLoading,
    };
  },
};
</script>

<style scoped>
.app-with-loading-container {
  display: flex;
  flex-direction: column;
}
.app-with-loading-slot {
  height: 100%;
}
</style>
